<mat-sidenav-container class="sidenav-container">
  <mat-sidenav
    *ngIf="!hideSidenav"
    #sidenav
    [mode]="isMobile ? 'over' : 'side'"
    [opened]="!isMobile"
    [disableClose]="!isMobile"
    class="sidenav"
    [class.sidenav-collapsed]="isCollapsed && !isMobile"
  >
    <div class="sidenav-content">
      <div class="sidenav-header">
        <button
          mat-icon-button
          (click)="onToggleClick()"
          class="toggle-button"
          [matTooltip]="getToggleTooltip()"
          matTooltipPosition="below"
        >
          <mat-icon>{{ getToggleIcon() }}</mat-icon>
        </button>

        <div
          class="header-content header-collapsed"
        >
          <ng-content select="[sidenavHeader]"></ng-content>
        </div>
      </div>

      <ng-content select="[sidenavList]"></ng-content>
    </div>
  </mat-sidenav>
  <mat-sidenav-content
    class="main-content"
    [class.content-expanded]="!hideSidenav && !isCollapsed && !isMobile"
    [class.content-collapsed]="!hideSidenav && isCollapsed && !isMobile"
    [class.content-mobile]="hideSidenav || isMobile"
  >
    <app-header [hideSidenav]="hideSidenav"></app-header>
    <main class="content-area">
      <ng-content select="[mainContent]"></ng-content>
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>
